import type { ReactNode } from 'react';
import { useQueryEditorContext } from './query-editor-context';

export interface QueryEditorModeContentProps {
  mode: string;
  children: ReactNode;
}

/**
 * Renders `children` only when the active mode from context matches `mode`. Unmounts otherwise so code-mode
 * editors (e.g. CodeMirror) release resources when switching away — same pattern as production PromQL editors.
 *
 * Requires `QueryEditor.Root` to receive a `mode` prop.
 */
export function QueryEditorModeContent({ mode: targetMode, children }: QueryEditorModeContentProps) {
  const { mode } = useQueryEditorContext();

  if (mode === undefined) {
    throw new Error('QueryEditor.ModeContent requires QueryEditor.Root to receive a `mode` prop.');
  }

  if (mode !== targetMode) {
    return null;
  }

  return children;
}
